import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PlatformCatalogSkill {
  id: number;
  title: string;
}

@Injectable({ providedIn: 'root' })
export class PlatformSkillsCatalogService {
  private readonly http = inject(HttpClient);
  private readonly catalog$: Observable<PlatformCatalogSkill[]> = this.http
    .get<PlatformCatalogSkill[]>(`${environment.apiBaseUrl}/general/skills`)
    .pipe(
      map((skills) =>
        [...skills].sort((a, b) =>
          a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
        )
      ),
      shareReplay(1)
    );

  /**
   * Loads approved skills from the shared skills catalog.
   * @returns Observable of catalog skills sorted by title
   */
  getSkills(): Observable<PlatformCatalogSkill[]> {
    return this.catalog$;
  }
}
